import React, { useState } from "react"
import { Container, Form} from "reactstrap"
import { useFormik } from "formik"
import Breadcrumbs from "../../../../components/Common/Breadcrumb"
import { useHistory, useParams } from "react-router-dom"
import ResultHandler from "../../../../components/ResultHandler"
import FormButtonHandler from "../../../../components/FormButtonHandler"
import { useResponse } from "../../../../hooks/useResponse"
import { useTranslation } from "react-i18next"
import { useGetInstence } from "../../../../hooks/useGetInstence"
import { PERSONAL_USE_REQUIRED_FIELDS } from "./CONSTANT"
import * as Yup from "yup"
import FineForm from "./PersonalUseForm"
import { editPersonalUse, getPersonalUse } from "../../../../api/personal-use"

const TYPES = {
    'select': null,
    'add-more': [],
    'checkbox': false,
    'file' : null
}

const initialValues = {}
const FIELDS_VALIDATION = {}

PERSONAL_USE_REQUIRED_FIELDS.forEach((f) => {
    initialValues[f.key] = TYPES[f.type] || "";
    
    if (f.type == "file") {
        FIELDS_VALIDATION[f.key + "_preview"] = Yup.string().required(
            "This Field Is Required"
        );
    } else if (f.type == "select" && f.isMulti) {
        FIELDS_VALIDATION[f.key] = Yup.array();
    } else {
        FIELDS_VALIDATION[f.key] = Yup.string().required("This Field Is Required");
    }
});

const EditPersonalUse = () => {
    let navigate = useHistory()
    const { t } = useTranslation()
    const {id: personalUseId} = useParams()
    const [editedPersonalUse, setEditedPersonalUse] = useState(null)

    const { instenceLoading, instenceError, instenceSuccess } = useGetInstence(
        getPersonalUse,
        personalUseId,
        response => {
            setEditedPersonalUse({
                ...response.data.privateUse
            })
        }
    )

    const { setData, loading, error, success } = useResponse(editPersonalUse, () => {
        navigate.goBack()
    })
    
    const validation = useFormik({
        enableReinitialize: true,
        initialValues: {...editedPersonalUse},
        validationSchema: Yup.object(FIELDS_VALIDATION),
        onSubmit: (values) => {
            setData({ type: "edit", id: personalUseId, data: values })
        },
    })

    return (
        <React.Fragment>
            <div className="page-content">
                <Container fluid={true}>
                    <Breadcrumbs
                        title={t("Personal Use")}
                        breadcrumbItem={t("btns.Edit") + " " + t("Personal Use")}
                    />
                    
                        {editedPersonalUse && (
                            <Form
                                className="needs-validation"
                                onSubmit={e => {
                                    e.preventDefault()
                                    validation.handleSubmit()
                                    return false
                                }}
                            >
                                <FineForm validation={validation} />

                                <FormButtonHandler btnTxt="Edit" loading={loading} />
                            </Form>
                        )}

                        <ResultHandler
                            loading={instenceLoading}
                            error={error}
                            success={success}
                            successMsg={"Updated Successfully!"}
                        />
                                
                </Container>
            </div>
        </React.Fragment>
    )
}

export default EditPersonalUse